import { TSnackbarPosition } from '@agco-onedigital/ecosystem-lib-web-components';

export const getDefaultSnackPosition = (isMobile: boolean): TSnackbarPosition => {
  const position: TSnackbarPosition = isMobile ? 'topRight' : 'topCenter';
  return position;
};
